import { useMutation } from 'react-query';
import { customerBusinessService } from 'src/services';

const removeDevice = async (token: string) => {
    const response = await customerBusinessService.removeAuthenticatedDevice({
        token: token,
    });
    return response.data.data;
};

export default function useRemoveDevice() {
    return useMutation((token: string) => removeDevice(token));
}
